import { createSelector } from 'reselect';
import { FAI_STATUS } from 'lib/constants';
import { getOffline } from './getOffline';
import { getIsAgentConnected } from './getIsAgentConnected';
import { getUnavailableStartAt } from './getUnavailableStartAt';
import { getFaultStartAt } from './getFaultStartAt';
import { getFAICurrentInspection } from './getFAICurrentInspection';
import { getStatusLabel } from './getStatusLabel';

export const getMachineHeaderState = createSelector(
  [
    getOffline,
    getIsAgentConnected,
    getUnavailableStartAt,
    getFaultStartAt,
    getFAICurrentInspection,
    getStatusLabel,
  ],
  (
    offline,
    isAgentConnected,
    unavailableStartAt,
    faultStartAt,
    currentInspection,
    status
  ) => {
    const fault = !!faultStartAt;
    if (offline) {
      return 'no internet connection';
    }
    if (!isAgentConnected && unavailableStartAt) {
      return 'edge device connection error';
    }
    const faiStatus = currentInspection?.status;
    if (faiStatus === FAI_STATUS.IN_PROGRESS) {
      return 'inspection in progress';
    }
    if (faiStatus === FAI_STATUS.PENDING) {
      return 'waiting for inspection';
    }
    if (faiStatus === FAI_STATUS.REJECTED) {
      return 'inspection rejected';
    }
    if (fault) {
      return 'in fault';
    }
    return status;
  }
);
